import * as constants from './constants'

export const fetchLocationDetails = locationId => ({
    type: constants.REQUEST_LOCATION_DETAILS,
    locationId,
})

export const locationDetailsReceived = entities => ({
    type: constants.LOCATION_DETAILS_RECEIVED,
    entities,
})

export const getRates = grsId => ({
    type: constants.GET_RATES,
    grsId,
})

export const setRates = rates => ({
    type: constants.SET_RATES,
    rates,
})
